var t=function(t){return["inherit"!==t&&"string"==typeof t?t:void 0,"number"==typeof t||"inherit"===t?t:void 0]};export{t as default};
